<nz-form-item>
  <nz-form-label nzFor="attribution">Attribution</nz-form-label>
  <nz-form-control [nzErrorTip]="error">
    <nz-select [formControl]="formControl" nzMode="default" nzPlaceHolder="Attribution" nzAllowClear [nzSize]="typeSize" class="w-100-p">
      <nz-option *ngFor="let attribution of vehicleAttributionValues" [nzValue]="attribution" [nzLabel]="attribution | vehicleAttributionName | nullCoal"></nz-option>
    </nz-select>
  </nz-form-control>
  <ng-template #error let-control>
    <ng-container *ngIf="control?.hasError('required')">
      L'attribution est requise
    </ng-container>
  </ng-template>
</nz-form-item>
